'use strict';

var useDebounce = require('../../../../../../../../_virtual/useDebounce.cjs');
var React = require('react');

var hasRequiredUseDebounce;

function requireUseDebounce () {
	if (hasRequiredUseDebounce) return useDebounce.__exports;
	hasRequiredUseDebounce = 1;

	var react = React;

	/**
	 * Custom debounce function
	 */ const debounce = (fn, delay = 0)=>{
	    let timeout;
	    const debounced = (...args)=>{
	        clearTimeout(timeout);
	        timeout = setTimeout(()=>{
	            fn(...args);
	        }, delay);
	    };
	    debounced.cancel = ()=>{
	        clearTimeout(timeout);
	    };
	    return debounced;
	};
	/**
	 * Debounce hook
	 */ const useDebounce$1 = (fn, delay)=>{
	    const ref = react.useRef(debounce(fn, delay));
	    return ref.current;
	};

	useDebounce.__exports.useDebounce = useDebounce$1;
	
	return useDebounce.__exports;
}

exports.__require = requireUseDebounce;
//# sourceMappingURL=useDebounce.cjs.map
